import services from "@/http";
import * as types from "./mutation-types";

export const ActionGetAll = async ({ commit }, payload) => {
  try {
    const { data } = await services.clientes.get_all(payload);
    commit(types.SET_CLIENTES, data.data);
    commit(types.SET_PAGINATION, data.meta);
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const ActionFind = async (store, payload) => {
  let response = { data: [], meta: {} };
  await services.clientes.get_all(payload).then((res) => {
    response = res.data;
  });
  return response;
};

export const ActionFindById = async ({ dispatch }, id) => {
  let response = null;
  await services.clientes.show({ id: id }).then((res) => {
    response = res.data.cliente;
  });
  return response;
};

export function formatBirthday(day) {
  if (day) {
    return day.replace(/(\d{4})-(\d{2})-(\d{2})/, "$3/$2/$1");
  }
  return "";
}

export const ActionShow = async ({ dispatch }, id) => {
  try {
    const { data } = await services.clientes.show({ id: id });

    if (data.cliente.pessoa_fisica) {
      data.cliente.pessoa_fisica.data_nascimento = formatBirthday(
        data.cliente.pessoa_fisica.data_nascimento
      );
    }
    dispatch("ActionSetCliente", data.cliente);
  } catch (error) {
    console.error("ActionShow", error);
  }
};

export const ActionSave = async ({ dispatch }, payload) => {
  if (payload.id) {
    await dispatch("ActionUpdate", payload);
    return;
  }

  await dispatch("ActionStore", payload);
};

function handleBirthday(payload) {
  if (payload.pessoa_fisica && payload.pessoa_fisica.data_nascimento) {
    const nascimento = payload.pessoa_fisica.data_nascimento;
    payload.pessoa_fisica.data_nascimento = nascimento.replace(
      /(\d{2})\/(\d{2})\/(\d{4})/,
      "$3-$2-$1"
    );
  }

  return payload;
}
export const ActionStore = async ({ commit }, payload) => {
  try {
    const auxPayload = handleBirthday(payload);
    const { data } = await services.clientes.store(auxPayload);
    commit(types.SET_CLIENTE, data.cliente);
  } catch (error) {
    console.error("SAVE ERROR:", error);
  }
};

export const ActionUpdate = async ({ commit }, payload) => {
  try {
    const auxPayload = handleBirthday(payload);

    const formatedId = { id: payload.id };
    const { data } = await services.clientes.update(formatedId, auxPayload);
    commit(types.SET_ERROR, {});
    commit(types.SET_CLIENTE, data.cliente);
  } catch (error) {
    commit(types.SET_ERROR, error);
  }
};

export const ActionDelete = async ({ commit }, payload) => {
  try {
    await services.clientes.delete({ id: payload });
    commit(types.SET_CLIENTE, { pessoa_juridica: {} });
  } catch (error) {}
};

export const ActionSetClientes = ({ commit }, payload) => {
  commit(types.SET_CLIENTES, payload);
};

export const ActionSetCliente = ({ commit }, payload) => {
  commit(types.SET_CLIENTE, payload);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};

export const ActionSetClienteUsers = async ({ commit }, payload) => {
  try {
    const { data } = await services.clientes.get_users(payload);
    commit(types.SET_CLIENTE_USERS, data.data);
    commit(types.SET_PAGINATION_USERS, data.meta);
  } catch (error) {}
};

export const ActionGetClientesPagamentos = async ({ commit }, payload) => {
  try {
    const { data } = await services.clientes.get_pagamentos(payload);
    commit(types.SET_CLIENTE_PAGAMENTOS, data.data);
    commit(types.SET_PAGINATION_PAGAMENTOS, data.meta);
  } catch (error) {}
};

export const ActionAddAssinatura = ({ commit }, payload) => {
  commit(types.SET_CLIENTE_ASSINATURA, payload);
};

export const ActionUpdateAssinatura = ({ commit }, payload) => {
  commit(types.UPDATE_CLIENTE_ASSINATURA, payload);
};

export const ActionRemoveAssinatura = ({ commit }, index) => {
  commit(types.REMOVE_CLIENTE_ASSINATURA, index);
};

export const ActionGetClientesByText = async ({ commit }, payload) => {
  try {
    const { data } = await services.clientes.get_by_text({ cliente: payload });

    return data;
  } catch (error) {
    console.error("Erro ao buscar clientes por texto:", error);
  }
};

export const ActionLinkToPartner = async ({ commit }, payload) => {
  try {
    const url = `api/clientes/link?parceiro_id=${payload.parceiro_id}&cliente_id=${payload.cliente_id}`;
    const { data } = await services.clientes.link_to_partner(
      { parceiro_id: payload.parceiro_id, cliente_id: payload.cliente_id },
      { url }
    );
    return data;
  } catch (error) {
    console.error("Erro ao buscar clientes por texto:", error);
  }
};

export const ActionNewCliente = ({ commit }) => {
  const cliente = {
    pessoa_juridica: {},
    pessoa_fisica: {},
    endereco: {
      cep: "",
      logradouro: "",
      numero: null,
      complemento: null,
      bairro: "",
      uf: null,
      cidade_id: null,
    },
    parceiro_id: null,
    parceiro: {},
    contatos: {
      emails: [],
      telefones: [],
      redes_sociais: [],
    },
    clientePlanos: [],
  };
  commit(types.SET_CLIENTE, cliente);
  commit(types.SET_CLIENTE_USERS, []);
};
